(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/login-iam/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/login-iam/assets/javascripts/constants.js');

'use strict';

const isServer = svs.isServer;
const POST_MESSAGE_SOURCE = 'svs-iam-parent';
const POST_MESSAGE_TYPES = {
  HEIGHT: 'height',
  SHOW_DIALOG: 'show-dialog',
  SHOW_DIALOG_RESOLVED: 'show-dialog-resolved',
  SHOW_DIALOG_EXTENDED: 'show-dialog-extended',
  SHOW_DIALOG_EXTENDED_RESOLVED: 'show-dialog-extended-resolved',
  PARENT_REDIRECT: 'parent-redirect',
  PARENT_REDIRECT_POST: 'parent-redirect-post',
  PARENT_RELOAD: 'parent-reload',
  FULLSCREEN: 'fullscreen',
  REMOVE_FULLSCREEN: 'remove-fullscreen',
  UPDATE_ONBOARDING_DATA: 'update-onboarding-data',
  SET_LOGIN_TYPE: 'set-login-type',
  UPDATE_PARENT_QUERYSTRING: 'update-parent-querystring',
  PARENT_QUERYSTRING_UPDATED: 'parent-querystring-updated',
  PARENT_ONBOARDING_DATA_UPDATED: 'parent-onboarding-data-updated',
  GET_PARAMS_FROM_URL: 'get-params-from-url',
  PARENT_TRACK_EVENT: 'parent-track-event',
  PARENT_TRACK_EVENT_RESOLVED: 'parent-track-event-resolved'
};
const loginType = {
  BANKID: 'bankid',
  FREJAEID: 'frejaeid'
};
const route = {
  LOGIN_HOME_ROUTE: '/',
  REGISTRATE_HOME_ROUTE: '/registrering',
  LOGIN_BANKID_ROUTE: '/inloggning/bankid',
  REGISTRATE_BANKID_ROUTE: '/registrering/bankid',
  LOGIN_BANKID_START_ROUTE: '/inloggning/bankid/start',
  LOGIN_BANKID_POLL_QR_ROUTE: '/inloggning/bankid/qr',
  LOGIN_BANKID_POLL_APP_ROUTE: '/inloggning/bankid/app',
  REGISTRATE_BANKID_START_ROUTE: '/registrering/bankid/start',
  REGISTRATE_BANKID_POLL_QR_ROUTE: '/registrering/bankid/qr',
  REGISTRATE_BANKID_POLL_APP_ROUTE: '/registrering/bankid/app',
  LOGIN_FREJAEID_ROUTE: '/inloggning/frejaeid',
  REGISTRATE_FREJAEID_ROUTE: '/registrering/frejaeid',
  LOGIN_FREJAEID_START_ROUTE: '/inloggning/frejaeid/start',
  LOGIN_FREJAEID_POLL_QR_ROUTE: '/inloggning/frejaeid/qr',
  LOGIN_FREJAEID_POLL_APP_ROUTE: '/inloggning/frejaeid/app',
  REGISTRATE_FREJAEID_POLL_ROUTE: '/registrering/frejaeid/start',
  REGISTRATE_FREJAEID_POLL_QR_ROUTE: '/registrering/frejaeid/qr',
  REGISTRATE_FREJAEID_POLL_APP_ROUTE: '/registrering/frejaeid/app'
};
const constExports = {
  loginType,
  route,
  POST_MESSAGE_TYPES,
  POST_MESSAGE_SOURCE
};
if (isServer) {
  module.exports = constExports;
} else {
  svs.login_iam.constants = constExports;
}

 })(window);